import SireneSyncButton from '@/producers/stores/components/SireneSyncButton'
import {ProducerStore} from '@/types'
import {Box, Chip, Typography} from '@mui/material'
import React from 'react'
import {DateInput, FunctionField, TextInput} from 'react-admin'

export default function FieldsInfosSirene() {
	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			gap: 2
		}}>
			<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1}}>
				<Typography variant="h6">Informations SIRENE</Typography>
				<SireneSyncButton size="small"/>
			</Box>

			<FunctionField
				source="administrative_status"
				label="Statut administratif"
				render={(record: ProducerStore) => {
					if (!record.administrative_status) {
						return <Typography variant="body2" color="text.secondary">Non renseigné</Typography>
					}
					const isActive = record.administrative_status === 'A'
					return (
						<Chip
							label={isActive ? 'Actif (A)' : 'Fermé (F)'}
							color={isActive ? 'success' : 'error'}
							size="medium"
						/>
					)
				}}
			/>

			<TextInput
				label="Code APE"
				source="code_ape"
				fullWidth
				disabled
				helperText="Code d'activité principale de l'établissement (mis à jour automatiquement)"
			/>

			<TextInput
				label="Effectifs"
				source="effectifs"
				fullWidth
				disabled
				helperText="Nombre d'employés de l'établissement (mis à jour automatiquement)"
			/>

			<DateInput
				label="Date de cessation"
				source="cessation_date"
				fullWidth
				disabled
				helperText="Date de cessation d'activité si l'établissement est fermé"
			/>

			<DateInput
				label="Dernière synchronisation SIRENE"
				source="sirene_last_update"
				fullWidth
				disabled
				helperText="Dernière mise à jour depuis l'API SIRENE de l'INSEE"
			/>

			<Typography variant="caption" color="text.secondary" sx={{mt: 1}}>
				Ces informations sont synchronisées automatiquement avec l'API SIRENE de l'INSEE
			</Typography>
		</Box>
	)
}
